import * as React from 'react'
import styled from 'styled-components'
import { media } from '~/components/GlobalStyle'

export const LoginMain = styled.main`
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding-top: 25%;
  background-color: ${({ theme }) => theme.loginBgColor || 'transparent'};

  .logo {
    max-height: 100px;
    max-width: 180px;
  }

  .card {
    margin-top: 12px;
    width: 95%;
    min-width: 310px;
    max-width: 350px;
    text-align: center;
    font-size: 0.9em;
  }

  ${media.small} {
    padding-top: 10%;

    .card {
      width: 100%;
      max-width: 420px;
    }
  }
`

export const Main = styled.main`
  position: relative;
  background-color: ${(props) => props.theme.content.bgColor || '#f1f6fb'};
  min-height: 100vh;

  ${media.medium} {
    padding-left: var(--sidebar-width);
  }
`

export const PageWrapper = styled.div`
  // position: relative;
`

export const Spacer = styled.div<{ height?: string }>`
  display: block;
  width: 100%;
  height: ${(props) => (props.height ? props.height : '0')};
`

const StyledContentWrapper = styled.div`
  padding: 24px 16px calc(65px + 18px);
  min-height: 100vh;

  ${media.medium} {
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 24px;
  }
`

export function ContentWrapper({ children }: { children: React.ReactNode }) {
  const headerHeight = document.getElementById('site-header')
    ? document.getElementById('site-header')?.offsetHeight
    : 120
  const [paddingTop, setPaddingTop] = React.useState(0)

  React.useEffect(() => {
    if (headerHeight) {
      setPaddingTop(headerHeight + 18)
    }
  }, [])

  return (
    <StyledContentWrapper style={{ paddingTop: `${paddingTop}px` }}>
      {children}
    </StyledContentWrapper>
  )
}
